module.exports = __webpack_public_path__ + "static/2-e152411437eb8ffe6354eaa7eaa9bde9.jpg";